import { reactive } from 'vue'

export const menu = reactive({
  toggled: false,
  changeToggled() {
    this.toggled = !this.toggled;
  }
})